import { Component, OnInit, ViewChild} from '@angular/core';
import { QuarriesService } from 'src/app/services/quarries.service';
import { PopupService } from 'src/app/core/popupmessage/popupmessage.service';
import { NavigationService } from 'src/app/services/nav.service';
import { DeliveryRateService } from 'src/app/services/deliveryRate.service';
import { HaulRate } from 'src/app/objects/HaulRate.class';
import { UtilityService } from 'src/app/services/utility.service';
import { MapsService } from 'src/app/services/maps.service';

@Component({
    selector: 'deliver-rate-finder',
    styleUrls:["DeliveryRateFinder.styles.css"],
    templateUrl: './DeliveryRateFinder.component.html',
})
export class DeliveryRateFinderComponent implements OnInit  {
    loadMap:boolean = false
    loadingRates:boolean = false;
    center: google.maps.LatLngLiteral = {lat: 38.62000137887169, lng: -90.18944084560322};
    zoom = 4;
    mapId = 'RSGMAP001'
    marker?:google.maps.marker.AdvancedMarkerElement
    display?: google.maps.LatLngLiteral;
    map?:google.maps.Map;
    placeAutocomplete?:google.maps.places.PlaceAutocompleteElement
    markers: google.maps.marker.AdvancedMarkerElement[] = [];
    options: google.maps.MapOptions = {
        center: {lat: 38.6257, lng: -90.1844},
        zoom: 10,
        mapId : 'RSGMAP001'
        ,disableDoubleClickZoom:true
        ,fullscreenControl:false
        ,streetViewControl:false
        ,cameraControl:false
    };
    rateSource:{rateAddress:string, lat:string, lng:string}={
        rateAddress:"",lat:"",lng:""
    }
    addressInput:string = ""

    deliveryRates:HaulRate[]=[];
    
    
    
    constructor(private quarrySrv:QuarriesService, private msgSrv:PopupService, private navSrv:NavigationService, private deliveryRateSrv:DeliveryRateService, private utilSrv:UtilityService
        ,private mapsSrv:MapsService
    ){}

    ngOnInit(): void {
        this.navSrv.setSubTitle("Delivery Rate Finder")
        console.log("DeliveryRateFinderComponent Loaded" )
        this.mapsSrv.loadApiScript().then(() => {
            console.log('Success')
                console.log("Loading Google Map Componenet now" )
                this.loadMap = true;
                setTimeout(()=>{
                    this.createAutoComplete();
                },500)
        })
        
    }

    public mapInitialized(event: google.maps.Map){
        this.map = event;
        
    }

    public moveMap(event: google.maps.MapMouseEvent) {
        if(event.latLng !== null){
            this.center = (event.latLng.toJSON());
        }
        this.getClickPlaceId(event);
    }

    private getClickPlaceId(click:any){
        if(typeof click.placeId !== "undefined" && click.placeId !== null){
            console.log(click.placeId)
        }
    }

    public move(event: google.maps.MapMouseEvent) {
        if(event.latLng !== null){
            this.display = event.latLng.toJSON();
        }
    }
    
    public mapDblclick(event:google.maps.MapMouseEvent){
        console.log(event);
        this.clearRateSource();
        if(this.marker == null || typeof this.marker == "undefined" || this.marker.map === null){
            this.setMarker(event.latLng)
            this.getDeliverRates(event.latLng);
        }else{
            this.marker.map = null;
        }
    }

    public mapclick(event:google.maps.MapMouseEvent){
        console.log("single click")
        console.log(event);
    }

    private setMarker(latLng:google.maps.LatLng|null){
        if(typeof this.marker !== "undefined"){
            this.marker.map = null;
        }
        const pinStyle = new google.maps.marker.PinElement({
            background: '#044fa5',
            borderColor: '#888',
            glyphColor: '#044fa5',
        });
        this.marker = new google.maps.marker.AdvancedMarkerElement({map:this.map,position:latLng,title:"Dbl Click Marker",content:pinStyle.element});
        if(typeof latLng?.lat() !== "undefined" && typeof latLng?.lng() !== "undefined"){
            this.map?.setCenter({lat:latLng?.lat(),lng:latLng?.lng()})
        }
    }

    private getDeliverRates(latLng:google.maps.LatLng|{lat:number,lng:number}|null){
        if(latLng !== null){
            if(latLng instanceof google.maps.LatLng){
                console.log("is google latLng",latLng)
                this.getRatesForLatLng(latLng.lat(),latLng.lng())
            }else{
                console.log("is not google latLng",latLng);
                this.getRatesForLatLng(latLng.lat,latLng.lng)
            }
        }else{
            console.error("latLng is null");
        }
    }

    private getRatesForLatLng(lat:number,lng:number){
        this.deliveryRates = [];
        this.rateSource.lng = lng.toString();
        this.rateSource.lat = lat.toString();
        console.log("Getting Rates");
        this.loadingRates = true;
        this.deliveryRateSrv.getHaulRate(lat,lng).then((result)=>{
            console.log("data returned")
            console.log(result)
            this.deliveryRates = result;
            this.deliveryRates.sort(this.utilSrv.sortObjectProp("deliveryRate"))
            this.loadingRates = false;
        }).catch((err)=>{
            this.loadingRates = false;
            console.error(err);
            if(err.status === 401){
                this.msgSrv.ok("Access Denied","Login required","",2,true).subscribe(()=>{
                    this.navSrv.navigateTo("login")
                })
                
            }
        })
    }

    public getAddress(){
        let ele = document.getElementById("rsg-address-input") as HTMLInputElement;
        this.clearRateSource();
        this.rateSource.rateAddress = ele.value;
        this.getGecodeAddress(ele.value)
    }

    private getGecodeAddress(address:string){
        this.mapsSrv.geocodeAddress(address).then((latLng)=>{
            this.setMarker(latLng);
            this.getDeliverRates(latLng);
            this.map?.setZoom(14)
        })
    }


    private createAutoComplete(){
        const originInput = document.getElementById(
            "rsg-address-input"
        ) as HTMLInputElement;

        const autocomplete = new google.maps.places.Autocomplete(
            originInput,
            { fields: ["formatted_address", "geometry", "name"],componentRestrictions:{ country:["US"]} }
          );

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if(typeof place.geometry !== "undefined" && typeof place.geometry?.location !== "undefined"){
                this.clearRateSource();
                this.rateSource.rateAddress = typeof place.formatted_address === "undefined" ? "": place.formatted_address;
                this.setMarker(place.geometry?.location)
                this.getDeliverRates(place.geometry?.location);
            }else{
                console.log("place.geometry.location IS undefiened",place);
                if(typeof place.formatted_address !== "undefined"){
                    this.getGecodeAddress(place.formatted_address)
                }else(
                    this.getAddress()
                )
            }
        });
    }

    private clearRateSource(){
        this.rateSource.rateAddress = "";
        this.rateSource.lat = "";
        this.rateSource.lng = "";
    }
}
